import TagManager from 'react-gtm-module';

export const FIRST_DEPOSIT_EVENT = 'first_deposit';
export const NEOPLAY24_ORIGIN = 'https://neoplay24.com';
export const GTM_ID = 'GTM-KC8CGL8D';

export type DataLayerEvent = {
  event: string;
  value: number;
  currency: string;
  transaction_id: string;
};

type FirstDepositTransaction = {
  id: string;
  amount: number;
};

export const isNeoplay24Origin = (origin?: string) => {
  if (typeof window === 'undefined' && !origin) {
    return false;
  }

  const resolvedOrigin = origin ?? window.location.origin;

  return resolvedOrigin === NEOPLAY24_ORIGIN;
};

export const buildFirstDepositEvent = (transaction: FirstDepositTransaction, currency: string): DataLayerEvent => ({
  event: FIRST_DEPOSIT_EVENT,
  value: Math.abs(transaction.amount),
  currency,
  transaction_id: transaction.id,
});

export const initializeGtm = (origin?: string) => {
  if (!isNeoplay24Origin(origin) || typeof document === 'undefined') {
    return;
  }

  const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${GTM_ID}"]`);

  if (existingScript) {
    return;
  }

  console.log(`[GTM] initialize with id: ${GTM_ID}`);

  TagManager.initialize({
    gtmId: GTM_ID,
  });
};

export const pushDataLayerEvent = (payload: DataLayerEvent, origin?: string) => {
  if (typeof window === 'undefined' || !isNeoplay24Origin(origin)) {
    return;
  }

  TagManager.dataLayer({ dataLayer: payload });
};
